import React from 'react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[hsl(215,65%,22%)] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo and Company Info */}
          <div>
            <div className="bg-white p-4 rounded-lg mb-4 inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_903e5963-72e7-475f-b460-9902e41c4ee5/artifacts/h8peuqt0_8df8d676-d288-4871-a8e4-e2e9366a1aaa.png" 
                alt="PA Global" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-300 leading-relaxed">
              Expert property consultancy for real estate professionals specializing in private sector, social housing, and residential properties.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4 text-white uppercase tracking-wide">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-[#a0d8f1] transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-[#a0d8f1] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-[#a0d8f1] transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold mb-4 text-white uppercase tracking-wide">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Private Sector Properties</li>
              <li>Social Housing Consultancy</li>
              <li>Residential Property Advice</li>
              <li>Market Analysis</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-4 text-white uppercase tracking-wide">Contact Us</h4>
            <ul className="space-y-3">
              <li className="text-gray-300">
                Larnaca, Cyprus
              </li>
              <li>
                <a href="tel:+35794592592" className="text-gray-300 hover:text-[#a0d8f1] transition-colors">
                  +357 94 592 592
                </a>
              </li>
              <li>
                <a href="mailto:info@paglobalgroup.com" className="text-gray-300 hover:text-[#a0d8f1] transition-colors">
                  info@paglobalgroup.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-600 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} PA Global Management & Consultancy. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
